import BatchCreateForm from "./BatchCreateForm"

export default BatchCreateForm

